import { render } from "./series-discount-list.vue?vue&type=template&id=ce6f4f2a&scoped=true&ts=true"
import script from "./series-discount-list.vue?vue&type=script&lang=ts"
export * from "./series-discount-list.vue?vue&type=script&lang=ts"

import "./series-discount-list.vue?vue&type=style&index=0&id=ce6f4f2a&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6f4f2a"]])

export default __exports__